import { useEffect, useRef, useState } from 'react';

/** Let canvas selection/drag finish before mounting an expensive inspector. Keyboard changes still settle next task. */
export default function usePointerSettledValue<T>(value: T): T {
	const [settled, setSettled] = useState(value);
	const latest = useRef(value);
	latest.current = value;
	const held = useRef(false);
	const timer = useRef<ReturnType<typeof setTimeout>>();
	const schedule = useRef(() => {});
	schedule.current = () => {
		clearTimeout(timer.current);
		if (!held.current) {
			timer.current = setTimeout(() => setSettled(latest.current), 0);
		}
	};
	useEffect(() => {
		const down = () => { held.current = true; clearTimeout(timer.current); };
		const up = () => { held.current = false; schedule.current(); };
		window.addEventListener('pointerdown', down, true);
		window.addEventListener('pointerup', up, true);
		window.addEventListener('pointercancel', up, true);
		window.addEventListener('blur', up);
		return () => {
			clearTimeout(timer.current);
			window.removeEventListener('pointerdown', down, true);
			window.removeEventListener('pointerup', up, true);
			window.removeEventListener('pointercancel', up, true);
			window.removeEventListener('blur', up);
		};
	}, []);
	useEffect(() => { schedule.current(); }, [value]);
	return settled;
}
